import axiosInstance from "./index";

const axios = axiosInstance

export const getTest = () => {return axios.get(`https://biobigdata.nju.edu.cn/api/sojak/browser`)}

export const getSojakGene = () => {return axios.get(`https://biobigdata.nju.edu.cn/api/sojak`)}

export const getSojakDetail = gene_id => {return axios.get('https://biobigdata.nju.edu.cn/api/sojak/details/'+gene_id)}

export const getBrowserUrl = (trackHeight, trackName, trackColor) => {
  return axios.post(`https://biobigdata.nju.edu.cn/api/sojak/browser`, 
  {"trackHeight": trackHeight, "trackName": trackName, "trackColor": trackColor})
}

export const postSeqFile = (sequence, type) => {
  if(type === 'file') {
    let param = new FormData()
    const config = {
      headers: {'Content-Type': 'multipart/form-data'}
    }
    param.append('sequence', sequence)
    return axios.post(`https://biobigdata.nju.edu.cn/api/sojak/sequence`, param, config)
  }else{
    return axios.post(`https://biobigdata.nju.edu.cn/api/sojak/sequence`, {'sequence': sequence})
  }
  
  
  
}

export const postBlastParams = (fileName, targetType, program, eValue, compMatrix, wordLength, resultNum, allowGap, emailContent) => {
  return axios.post(`https://biobigdata.nju.edu.cn/api/sojak/blast`, {
    'fileName': fileName,
    'targetType': targetType,
    'program': program,
    'eValue': eValue,
    'compMatrix': compMatrix,
    'wordLength': wordLength,
    'resultNum': resultNum,
    'allowGap': allowGap,
    'emailContent': emailContent
  }, {timeout: 1000*60*60})
}